import React from 'react'
import { Navbar, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { StyledBrand, StyledContainer } from './styled'
import { useLocation } from 'react-router-dom'
import LogoFr from './../../common/images/logoFr.svg'
import LogoFrNegativo from './../../common/images/logoFrNegativo.svg'
import FacebookLogo from './../../common/images/facebook.svg'
import LinkedinLogo from './../../common/images/linkedin.svg'
import InstagramLogo from './../../common/images/instagram.svg'

import { NavigationBar, NavList, NavListItem } from './../../components'

const Header = () => {
    const location = useLocation()

    const isCurrentLocation = (pathname) => {
        return location.pathname === pathname
    }

    // console.log('location:>> ', location)
    // if(location.pathname === '/') return <></>

    return (
    <Navbar bg="primary" variant="dark" expand='lg'>
             <StyledContainer fluid>
                
                 <Col xs={3} lg={2} className='d-flex justify-content-center'>
                     <Link to='/'>
                         <StyledBrand>
                             <img className='d-none d-lg-block' src={LogoFr} alt='' />
                             <img className='d-block d-lg-none' src={LogoFrNegativo} alt=''/>
                         </StyledBrand>
                     </Link>
                 </Col>
                
                 <Col lg={8} md={1} className='d-none d-lg-flex'>
                     <NavigationBar isCurrentLocation={isCurrentLocation}/>   
                 </Col>

                 <Col lg={2} xl={1} md={1} xs={2} >
                     <NavList className='d-none d-lg-flex'>
                         <NavListItem>
                             <a target='_blank' href='https://www.facebook.com/frinstalacoes'>
                                 <img src={FacebookLogo} alt=''/>
                             </a>
                         </NavListItem>

                         <NavListItem>
                             <a target='_blank' href='https://www.linkedin.com/company/frinstalacoes'>
                                 <img src={LinkedinLogo} alt=''/>
                             </a>
                         </NavListItem>
                        
                     </NavList>
                     <Navbar.Toggle className='px-1 py-1'/>
                 </Col>

                 <Navbar.Collapse>
                     <div className='d-block d-lg-none'>
                     <NavigationBar  isCurrentLocation={isCurrentLocation}/>        
                     </div>
                 </Navbar.Collapse>

             </StyledContainer>

         </Navbar>)
    
}

export default Header